import { render, staticRenderFns } from "./ProposalComments.vue?vue&type=template&id=2cf2d38f&"
import script from "./ProposalComments.vue?vue&type=script&lang=js&"
export * from "./ProposalComments.vue?vue&type=script&lang=js&"
import style0 from "./ProposalComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports